import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { FaMapMarkerAlt, FaClipboardList, FaShoppingBag, FaInstagram, FaWhatsapp, FaTiktok } from 'react-icons/fa';
import './LinksPage.css';
import { subscribeLinks } from '../services/linktreeService';

const ICONS = {
  Map: <FaMapMarkerAlt />,
  Clipboard: <FaClipboardList />,
  Bag: <FaShoppingBag />,
  Instagram: <FaInstagram />,
  WhatsApp: <FaWhatsapp />,
};

const defaultLinks = [
  {
    icon: 'Map',
    label: 'Visit our Al Wakrah branch',
    url: 'https://maps.app.goo.gl/9Dn4GvEbAEnGdHUA9',
    sublabel: 'Open daily 7 AM - 11 PM',
  },
  {
    icon: 'Map',
    label: 'Visit our Gewan Island branch',
    url: 'https://maps.app.goo.gl/tLp1jS6tT8sR4kGg9',
    sublabel: 'Open daily 8 AM - 12 AM',
  },
  {
    icon: 'Clipboard',
    label: 'View Gewan Menu',
    url: '/menu/gewan',
    sublabel: '',
  },
  {
    icon: 'Bag',
    label: 'Admin Panel',
    url: '/admin',
    sublabel: '',
  },
];

const socialLinks = [
  {
    icon: <FaInstagram />,
    url: 'https://instagram.com/greydoha',
    label: 'Instagram',
  },
  {
    icon: <FaWhatsapp />,
    url: 'https://wa.me/97450008852',
    label: 'WhatsApp',
  },
  {
    icon: <FaTiktok />,
    url: 'https://www.tiktok.com/@greydoha',
    label: 'TikTok',
  },
];

const LinksPage = () => {
  const [links, setLinks] = useState(defaultLinks);

  useEffect(() => {
    const unsubscribe = subscribeLinks((fetched) => {
      setLinks(fetched.length ? fetched : defaultLinks);
    });
    return () => unsubscribe();
  }, []);

  return (
    <>
      <Header />
      <div className="links-page-container">
        <div className="links-page-card">
          <header className="links-page-header">
            <h2 className="links-title">Quick links</h2>
            <div className="links-divider"></div>
          </header>

          <main className="links-page-main">
            {links.map((link, index) => (
              <a
                key={index}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="link-button"
              >
                <div className="link-button-icon">{ICONS[link.icon]}</div>
                <div className="link-button-text">
                  <span className="link-button-label">{link.label}</span>
                  {link.sublabel && <span className="link-button-sublabel">{link.sublabel}</span>}
                </div>
                <span className="link-button-arrow">→</span>
              </a>
            ))}
          </main>

          <div className="links-footer-divider"></div>
          <footer className="links-page-footer">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label={social.label}
              >
                {social.icon}
              </a>
            ))}
          </footer>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default LinksPage; 